import { makeImmutable } from "../../core/makeImmutable";
export class SalesChannel {
    constructor(value) {
        this.value = value;
        makeImmutable(this);
    }
    static create(isQrWaiterOrder, mobileAppType) {
        if (isQrWaiterOrder) {
            return SalesChannel.QRWaiter;
        }
        switch (mobileAppType) {
            case "IosApp":
                return SalesChannel.IosApp;
            case "AndroidApp":
                return SalesChannel.AndroidApp;
        }
        return SalesChannel.Sites;
    }
    get associationKey() {
        return this.toString();
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        if (this == SalesChannel.Sites) {
            return { tag: "Online" };
        }
        else if (this == SalesChannel.QRWaiter) {
            return { tag: "Bar" };
        }
        else if (this == SalesChannel.IosApp) {
            return { tag: "IosApp" };
        }
        else if (this == SalesChannel.AndroidApp) {
            return { tag: "AndroidApp" };
        }
        else {
            return { tag: "Other" };
        }
    }
    get menuOrderOrigin() {
        if (this == SalesChannel.Sites ||
            this == SalesChannel.AndroidApp ||
            this == SalesChannel.IosApp) {
            return "Online";
        }
        else if (this == SalesChannel.QRWaiter) {
            return "Bar";
        }
        else {
            return "Other";
        }
    }
}
SalesChannel.Sites = new SalesChannel("Sites");
SalesChannel.QRWaiter = new SalesChannel("QRWaiter");
SalesChannel.IosApp = new SalesChannel("IosApp");
SalesChannel.AndroidApp = new SalesChannel("AndroidApp");
